/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Ad_Job_TitleInputs */

const en_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete AD Job`)
};

const fr_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'offre d'emploi AD`)
};

const de_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Auftrag löschen`)
};

const it_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina processo AD`)
};

const ru_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить задание AD`)
};

const es_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar trabajo de AD`)
};

const zh_cn2_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除 AD 作业`)
};

const ja_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADジョブの削除`)
};

const hi_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD जॉब हटाएं`)
};

const pt_pt2_delete_ad_job_title = /** @type {(inputs: Delete_Ad_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir tarefa de anúncio`)
};

/**
* | output |
* | --- |
* | "Delete AD Job" |
*
* @param {Delete_Ad_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_ad_job_title = /** @type {((inputs?: Delete_Ad_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Ad_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_ad_job_title(inputs)
	if (locale === "de") return de_delete_ad_job_title(inputs)
	if (locale === "it") return it_delete_ad_job_title(inputs)
	if (locale === "ru") return ru_delete_ad_job_title(inputs)
	if (locale === "es") return es_delete_ad_job_title(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_ad_job_title(inputs)
	if (locale === "ja") return ja_delete_ad_job_title(inputs)
	if (locale === "hi") return hi_delete_ad_job_title(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_ad_job_title(inputs)
	return en_delete_ad_job_title(inputs)
});